// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SeenBeforeSection-module__layout___VcqpK {
  display: flex;
  align-items: flex-start;
  gap: 16px;
}

.SeenBeforeSection-module__body___QnWfi {
  flex: 1;
  min-width: 0;
}

.SeenBeforeSection-module__seen___zAWMw {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 0;
  font-size: 14px;
}

.SeenBeforeSection-module__seenIcon___ax7bb {
  flex-shrink: 0;
  margin-top: 3px;
}

.SeenBeforeSection-module__toneSeen___VCpKT {
  color: #52525b;
}

.SeenBeforeSection-module__toneNew___zeEKB {
  font-weight: 500;
  color: #0369a1;
}

.SeenBeforeSection-module__toneNone___efuxX {
  color: #a1a1aa;
}

.SeenBeforeSection-module__fromNote___ZE9Z0 {
  margin: 4px 0 0;
  font-size: 13px;
  color: #71717a;
}

.SeenBeforeSection-module__sections___cUgVB {
  margin-top: 8px;
  font-size: 14px;
  line-height: 1.55;
  color: #18181b;
}

.SeenBeforeSection-module__clamped___hyPub {
  max-height: 72px;
  overflow: hidden;
  -webkit-mask-image: linear-gradient(to bottom, #000 55%, transparent);
  mask-image: linear-gradient(to bottom, #000 55%, transparent);
}

.SeenBeforeSection-module__assessment___gpuJ_ {
  margin: 0;
  white-space: pre-line;
}

.SeenBeforeSection-module__sectionLabel___iL0dk {
  margin: 0 0 4px;
  font-size: 14px;
  font-weight: 600;
  color: #71717a;
}

.SeenBeforeSection-module__plan___rJTLL {
  margin: 4px 0 0;
  padding-left: 20px;
}

.SeenBeforeSection-module__plan___rJTLL li {
  margin-bottom: 6px;
  white-space: pre-line;
}

.SeenBeforeSection-module__toggle___iXkqt {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-top: 8px;
  padding: 0;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #0369a1;
  cursor: pointer;
}
.SeenBeforeSection-module__toggle___iXkqt:hover {
  text-decoration: underline;
}

.SeenBeforeSection-module__readNote___cZ6Vq {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #d4d4d8;
  border-radius: 6px;
  background: #ffffff;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #18181b;
  cursor: pointer;
}
.SeenBeforeSection-module__readNote___cZ6Vq:hover:not(:disabled) {
  border-color: #18181b;
}
.SeenBeforeSection-module__readNote___cZ6Vq:disabled {
  color: #a1a1aa;
  cursor: default;
}

.SeenBeforeSection-module__readNoteIcon___Y__zA {
  color: #71717a;
}

.SeenBeforeSection-module__error___mH9qb {
  margin: 8px 0 0;
  font-size: 13px;
  color: #b91c1c;
}

.SeenBeforeSection-module__earlier___FOtyE {
  padding: 6px 0;
}

.SeenBeforeSection-module__earlierLine___qlH0h {
  margin: 0;
  font-size: 14px;
  color: #18181b;
}

@container (max-width: 639px) {
  .SeenBeforeSection-module__layout___VcqpK {
    flex-wrap: wrap;
  }
  .SeenBeforeSection-module__body___QnWfi {
    flex-basis: 100%;
  }
  .SeenBeforeSection-module__earlier___FOtyE {
    border-top: 1px solid #f4f4f5;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/ProviderHudView/SeenBeforeSection.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AACF;;AAEA;EACE,OAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,gBAAA;EACA,qEAAA;EACA,6DAAA;AACF;;AAEA;EACE,SAAA;EACA,qBAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,kBAAA;EACA,qBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AACF;AACE;EACE,0BAAA;AACJ;;AAGA;EACE,oBAAA;EACA,cAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AAAF;AAEE;EACE,qBAAA;AAAJ;AAGE;EACE,cAAA;EACA,eAAA;AADJ;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAKA;EACE,cAAA;AAFF;;AAKA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AAFF;;AAIA;EACE;IACE,eAAA;EADF;EAIA;IACE,gBAAA;EAFF;EAKA;IACE,6BAAA;EAHF;AACF","sourcesContent":[".layout {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n}\n\n.body {\n  flex: 1;\n  min-width: 0;\n}\n\n.seen {\n  display: flex;\n  align-items: flex-start;\n  gap: 6px;\n  margin: 0;\n  font-size: 14px;\n}\n\n.seenIcon {\n  flex-shrink: 0;\n  margin-top: 3px;\n}\n\n.toneSeen {\n  color: #52525b;\n}\n\n.toneNew {\n  font-weight: 500;\n  color: #0369a1;\n}\n\n.toneNone {\n  color: #a1a1aa;\n}\n\n.fromNote {\n  margin: 4px 0 0;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.sections {\n  margin-top: 8px;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #18181b;\n}\n\n.clamped {\n  max-height: 72px;\n  overflow: hidden;\n  -webkit-mask-image: linear-gradient(to bottom, #000 55%, transparent);\n  mask-image: linear-gradient(to bottom, #000 55%, transparent);\n}\n\n.assessment {\n  margin: 0;\n  white-space: pre-line;\n}\n\n.sectionLabel {\n  margin: 0 0 4px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #71717a;\n}\n\n.plan {\n  margin: 4px 0 0;\n  padding-left: 20px;\n}\n\n.plan li {\n  margin-bottom: 6px;\n  white-space: pre-line;\n}\n\n.toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-top: 8px;\n  padding: 0;\n  border: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #0369a1;\n  cursor: pointer;\n\n  &:hover {\n    text-decoration: underline;\n  }\n}\n\n.readNote {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid #d4d4d8;\n  border-radius: 6px;\n  background: #ffffff;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #18181b;\n  cursor: pointer;\n\n  &:hover:not(:disabled) {\n    border-color: #18181b;\n  }\n\n  &:disabled {\n    color: #a1a1aa;\n    cursor: default;\n  }\n}\n\n.readNoteIcon {\n  color: #71717a;\n}\n\n.error {\n  margin: 8px 0 0;\n  font-size: 13px;\n  color: #b91c1c;\n}\n\n.earlier {\n  padding: 6px 0;\n}\n\n.earlierLine {\n  margin: 0;\n  font-size: 14px;\n  color: #18181b;\n}\n@container (max-width: 639px) {\n  .layout {\n    flex-wrap: wrap;\n  }\n\n  .body {\n    flex-basis: 100%;\n  }\n\n  .earlier {\n    border-top: 1px solid #f4f4f5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `SeenBeforeSection-module__layout___VcqpK`,
	"body": `SeenBeforeSection-module__body___QnWfi`,
	"seen": `SeenBeforeSection-module__seen___zAWMw`,
	"seenIcon": `SeenBeforeSection-module__seenIcon___ax7bb`,
	"toneSeen": `SeenBeforeSection-module__toneSeen___VCpKT`,
	"toneNew": `SeenBeforeSection-module__toneNew___zeEKB`,
	"toneNone": `SeenBeforeSection-module__toneNone___efuxX`,
	"fromNote": `SeenBeforeSection-module__fromNote___ZE9Z0`,
	"sections": `SeenBeforeSection-module__sections___cUgVB`,
	"clamped": `SeenBeforeSection-module__clamped___hyPub`,
	"assessment": `SeenBeforeSection-module__assessment___gpuJ_`,
	"sectionLabel": `SeenBeforeSection-module__sectionLabel___iL0dk`,
	"plan": `SeenBeforeSection-module__plan___rJTLL`,
	"toggle": `SeenBeforeSection-module__toggle___iXkqt`,
	"readNote": `SeenBeforeSection-module__readNote___cZ6Vq`,
	"readNoteIcon": `SeenBeforeSection-module__readNoteIcon___Y__zA`,
	"error": `SeenBeforeSection-module__error___mH9qb`,
	"earlier": `SeenBeforeSection-module__earlier___FOtyE`,
	"earlierLine": `SeenBeforeSection-module__earlierLine___qlH0h`
};
module.exports = ___CSS_LOADER_EXPORT___;
